fragment FeatureListFragment on featureList_Entry {
  typeHandle
  heading
  points {
    ... on pointsBlock_Entry {
      point
    }
  }
}
